import type { FocusTrap } from '@angular/cdk/a11y';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { NgTemplateOutlet } from '@angular/common';
import type { SimpleChanges, TemplateRef } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  input,
} from '@angular/core';

import { DropdownComponent } from '../../../common/dropdown/dropdown.component';

@Component({
  selector: 'rt-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DropdownComponent, NgTemplateOutlet],
})
export class SelectDropdownComponent {
  public readonly width = input<number | null>();
  public readonly minWidth = input<number | 'max-content' | null | undefined>(null);
  public readonly maxWidth = input<number | null | undefined>(null);
  public readonly noMaxHeight = input<boolean>(false);
  public readonly hasStickyFooter = input<boolean>(false);
  public readonly scrollTop = input<number>(0);
  public readonly footerTemplate = input<TemplateRef<any>>();
  public readonly footerTemplateContext = input<Record<string, any> | undefined>({});

  @ViewChild('rtDropdown', { static: true, read: ElementRef }) public rtDropdown: ElementRef;
  @ViewChild(DropdownComponent) public dropdownComponent: DropdownComponent;

  private _focusTrap: FocusTrap;

  constructor(
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    private _focusTrapFactory: FocusTrapFactory,
  ) {}

  public ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  public ngAfterViewInit(): void {
    if (!this._focusTrap) {
      this._focusTrap = this._focusTrapFactory.create(this.elRef.nativeElement);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.scrollTop && this.rtDropdown && this.rtDropdown.nativeElement) {
      this.rtDropdown.nativeElement.firstElementChild.scrollTop = changes.scrollTop.currentValue;
    }
  }

  public ngOnDestroy(): void {
    if (this._focusTrap) {
      setTimeout(() => {
        this._focusTrap.destroy();
      }, 0);
    }
  }

  public get minWidthAttr() {
    const minWidth = this.minWidth();
    return typeof minWidth === 'number' ? minWidth + 'px' : minWidth;
  }
}
